const statusTranslations = {
  PENDING: 'PENDIENTE',
  INITIAL: 'INICIAL',
  TO_BE_PAID: 'POR COBRAR',
  PAID: 'PAGADO',
  CANCELLATION_REQUEST: 'CANCELACIÓN SOLICITADA',
  CANCELLATION_CONFIRMED: 'SOLICITUD DE CANCELACIÓN CONFIRMADA',
  CANCELLED: 'CANCELADA',
  RE_INVOICE_REQUEST: 'REFACTURACIÓN SOLICITADA',
  RE_INVOICED: 'REFACTURADO'
}

function taxReceiptStatus(value) {
  return statusTranslations[value] || value
}

const taxReceiptStatuses = Object.keys(statusTranslations)

export {
  taxReceiptStatuses,
  statusTranslations,
  taxReceiptStatus,
}


// WEBPACK FOOTER //
// ./src/pages/TaxReceipt/utils.js